import { Button, Form, message, Modal, Popconfirm, Select, Switch } from "antd";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import GlobalWrap from "../../components/globalWrap";
import { ActionType, ProTable } from "@ant-design/pro-components";
import { PlusOutlined } from "@ant-design/icons";
import UUIDComponent from "../../components/UUIDComponent";
import RoleForm from "./RoleForm";
import moment from "moment";

export default function Role() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();
    const [form] = Form.useForm();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const deleteHandle = async (id: any) => {
        const result: any = await jsonRequest.delete(`/back/sys-role/delete/${id}`, {});
        if (result?.body.code === 0)
            message.success('删除成功');
        else {
            message.error('删除失败');
            console.log(result);
        }
        tableRef.current?.reload();
    }

    const handleEnableChange = (item: any, status: string) => {
        jsonRequest.put(`/back/sys-role/change-status/${item.id}`, {})
            .then((resp: any) => resp.json())
            .then((data: any) => {
                if (data.code === 0) {
                    message.success(`${status === 'ENABLE' ? "启用" : "禁用"}成功`);
                    tableRef.current?.reload();
                } else {
                    message.error(data.msg);
                }
            })
    }

    const handleUpdateOrInsert = (item: any) => {
        Modal.confirm({
            width: 500,
            title: !!item.id ? `角色编辑 - ${item.roleName}` : "角色新增",
            content: <GlobalWrap><RoleForm form={form} item={item} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                if (!!item?.id) {
                    await jsonRequest.put("/back/sys-role/modify", {
                        ...values,
                        id: item.id,
                    }).then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("编辑成功");
                            } else {
                                message.error(data?.msg || "编辑失败");
                            }
                        })
                } else {
                    await jsonRequest.post("/back/sys-role/add", { ...values })
                        .then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("新增成功");
                            } else {
                                message.error(data?.msg || "新增失败");
                            }
                        })
                }
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const columns: any[] = [
        {
            title: "序号",
            valueType: "index",
            search: false,
            align: "center",
            width: 50,
        },
        {
            title: "角色ID",
            dataIndex: "id",
            align: "center",
            search: false,
            width: 100,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "角色名称",
            dataIndex: "roleName",
            search: false,
            align: "center",
            width: 150,
        },
        {
            title: "排序",
            dataIndex: "sortNum",
            search: false,
            align: "center",
            width: 50,
        },
        {
            title: "备注",
            dataIndex: "remark",
            search: false,
            align: "center",
            width: 150,
        },
        {
            title: "状态",
            dataIndex: "status",
            search: true,
            align: "center",
            width: 70,
            render: (text: string, record: any) => (
                <Switch
                    size="small"
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    checked={text === 'ENABLE'}
                    onChange={(checked) => handleEnableChange(record, checked ? 'ENABLE' : 'DISABLE')}
                />
            ),
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder={'请选择状态'}
                    options={[
                        { label: "启用", value: 'ENABLE' },
                        { label: "禁用", value: 'DISABLE' },
                    ]}
                />
            ),
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            search: false,
            align: "center",
            width: 150,
            render: (text: any) => {
                return moment(text).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            align: "center",
            search: true,
            hideInTable: true,
            valueType: "dateRange",
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            fixed: 'right',
            width: 100,
            render: (_: any, record: any) => (
                <>
                    <Button type='link' size='small' onClick={() => handleUpdateOrInsert(record)}>
                        编辑
                    </Button>
                    <Popconfirm title="确定删除？" okText="是" cancelText="否"
                        onConfirm={() => deleteHandle(record.id)}>
                        <Button type='link' size='small' danger>删除</Button>
                    </Popconfirm>
                </>
            ),
        }
    ];

    const request = async (params: any) => {
        const result = await jsonRequest.get("/back/sys-role/page", {
            pageSize: params.pageSize,
            currentPage: params.current,
            status: params.status,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data.data, success: result.code === 0, total: data.count };
    };

    return <>
        <h1>角色管理</h1>
        <ProTable
            rowKey="id"
            actionRef={tableRef}
            scroll={{ x: 1000 }}
            cardBordered
            bordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [
                <Button
                    key="button"
                    icon={<PlusOutlined />}
                    onClick={() => handleUpdateOrInsert({})}
                    type="primary"
                >
                    新增
                </Button>
            ]}
        />
    </>;
}